import React, { useEffect, useState } from "react";
import { Parents } from "../utils/CartegoryParent";
import { AdminCreateBrand, AdminViewSingleCategory, addCategory, addSubCategoryAndBrand, getCategory } from "../utils/Api/ApiCalls";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";

const ViewCategoryForm = () => {
	const navigate = useNavigate();
	const params = useParams();
	const currentUser = useRecoilValue(userState);
	const [previewImageUrl, setPreviewImageUrl] = useState("");
	const [load, setLoad] = useState(false);
	const [showSubCategory, setShowSubCategory] = useState(false);
	const [ showSubmit, setShowSubmit ] = useState(false);
	const [allCartegory, setAllCartegory] = useState([]);
	const [ brands, setBrands ] = useState([]);
	const [ data, setData ] = useState({
		categoryName: "",
		description: ""
	});
	const [categoryData, setCategoryData] = useState({
		category: "",
		subcategories: [],
		brands: []
	});
	const [ newData, setNewData ] = useState({});
	
	const [formData, setFormData] = useState({
		name: "",
		description: "",
		category: "",
		images: null,
	});

 

	const OnHandleChange = (e) => {
		const { name, value, type, files } = e.target;
		if (type === "file") {
			const avatarFile = files[0];
			const url = URL.createObjectURL(avatarFile);
			setPreviewImageUrl(url);

			setFormData((prev) => ({
				...prev,
				[name]: avatarFile,
			}));
		} else {
			setFormData((prevProfile) => ({
				...prevProfile,
				[name]: value,
			}));
		}
	};

	useEffect(() => {
		getSingleCategory();
	}, [categoryData]);
	const getSingleCategory = async () => {
		try {
			const res = await getCategory(params.categoryId);
			
			setCategoryData({
				category: res.category,
				subcategories: res.subCategories,
				brands: res.brands
			});
			setData({
				categoryName: res.category.categoryName,
				description: res.category.description
			})
			console.log(res)
		} catch (err) {
			return err;
		}
	}

	
	const onAddSubCategory = async () => {
		setShowSubCategory(!showSubCategory);
		//setShowSubmit(true);
		const res = await addSubCategoryAndBrand({
			categoryId: params.categoryId,
			subcategory: newData.subcategory,
			brands: newData.brands
		});
		if (res) {
			
			Swal.fire({
				title: "SubCategory and Brands Added Successfully",
				icon: "success",
			}).then(() => {
				//window.location.reload();
			});
		}
	}
	const onCategoryChange = (e) => {
		const { name, value } = e.target;
		setData((prev) => ({
			...prev,
			[name]: value
		}))
	}
	const onNewSubCategoryChange = (e) => {
		const { name, value } = e.target;
		setNewData((prev) => ({
			...prev,
			[name]: value
		}))
	}
	const onAddCategory = async () => {
		//alert(JSON.stringify(categoryData));
		
		const res = await addCategory(categoryData);
		if (res) {
			
			Swal.fire({
				title: "Category Created Successfully",
				icon: "success",
			}).then(() => {
				//window.location.reload();
 navigate("/categories");
			});
		}
	}
	const onSubCategoryChange = (e) => {
		const { value } = e.target;

		console.log(categoryData);
		
		
        let data = categoryData.brands.filter((item, i) => item.subCategoryId === parseInt(value));
		setBrands(data[0]?.brandName.split(","));
	}

	return (
		<div>
			<section class='content-main'>
				<div class='row'>
					<div class='col-12'>
						<div class='content-header'>
							<h2 class='content-title'>View Category</h2>
							<div>
								{showSubmit ?
								<button
									onClick={onAddCategory}
									class='btn btn-md rounded font-sm hover-up'>
									Submit
								</button>: ""
                               }
							</div>
						</div>
					</div>

				</div>
				<div className="row">
					<div class='col-md-6'>
						<div class='card mb-4'>
							{/* <div class='card-header'>
								<h4>Basic</h4>
							</div> */}
							<div class='card-body'>
								<form>
									<div class='mb-3'>
										<label for='product_name' class='form-label'>
											Category name <span style={{ color: 'red' }}>*</span>
										</label>
										<input
											required
											name='category'
											onChange={onCategoryChange}
											value={data.categoryName}
											type='text'
											placeholder='Type here'
											class='form-control'
											id='category_name'
										/>
									</div>
									<div className="row">
										<div className="col-md-6 mb-3">
											<label class='form-label'>Sub Category</label>
											<select
												id="subcategory"
												name='subcategory'
												onChange={onSubCategoryChange}
												className='form-select'>
												<option value="">--Select sub category--</option>

												{categoryData && categoryData.subcategories?.map((item, i) => (
													<option key={"category"+(i+1)} value={item.ID}>
														{item.subCategoryName}
													</option>
												))}
											</select>
										</div>
										<div className="col-md-6 mb-3">
											<label class='form-label'>Brands</label>
											<select
												id="brand"
												name='brands'
												// onChange={OnHandleChange}
												className='form-select'>
												<option value="">--Select brand--</option>

												{brands?.map((item, i) => (
													<option key={"brand"+i} value={item}>
														{item}
													</option>
												))}
											</select>
										</div>
									</div>
									<div className="row">
									<div class='col-md-12 mb-4'>
										<label class='form-label'>Full description<span style = {{color : 'red'}}>*</span></label>
										<textarea
											required
											name='description'
											onChange={onCategoryChange}
											value={data.description}
											placeholder='Type here'
											class='form-control'
											rows='4'></textarea>
									</div>
									</div>
									<div className="row mb-3" >
										<div
											role="button"
											className="col-md-12 d-flex justify-content-end"
											style={{ color: '#bb2d5e', fontWeight: 400 }}
											onClick={() => setShowSubCategory(!showSubCategory)}>
											<i class="material-icons md-post_add"></i><span>Add Subcategory</span>
										</div>
									</div>

								</form>
							</div>
						</div>
						{/* <!-- card end// --> */}
					</div>
					{/* </div> */}
					{showSubCategory ?
						// <div className="row">
						<div class='col-md-6'>
							<div class='card mb-3'>
								<div class='card-header'>
									<h4>New Sub Category</h4>
								</div>
								<div class='card-body'>
									<form>

										<div class='mb-3'>
											<label for='product_name' class='form-label'>
												Sub-Category name <span style={{ color: 'red' }}>*</span>
											</label>
											<input
												required
												name='subcategory'
												onChange={onNewSubCategoryChange}
												type='text'
												placeholder='Type here'
												class='form-control'
												id='subcategory_name'
											/>
										</div>
										<div class='mb-3'>
											<label for='product_name' class='form-label'>
												Brands (comma separated list) <span style={{ color: 'red' }}>*</span>
											</label>
											<input
												required
												name='brands'
												onChange={onNewSubCategoryChange}
												type='text'
												placeholder='Type here'
												class='form-control'
												id='subcategory_name'
											/>
										</div>
										{/* <div class='mb-4'>
										<label class='form-label'>Full description<span style = {{color : 'red'}}>*</span></label>
										<textarea
											required
											name='description'
											onChange={OnHandleChange}
											placeholder='Type here'
											class='form-control'
											rows='4'></textarea>
									</div> */}
										<div className="d-flex justify-content-end">
											{/* <button class='btn btn-light rounded font-sm mr-5 text-body hover-up'>
									Save to draft
								</button> */}

											{load ? (
												<button
													disabled
													class='btn btn-md rounded font-sm hover-up'>
													Loading...
												</button>
											) : (
												<button
													onClick={onAddSubCategory}
													class='btn btn-md rounded font-sm hover-up'>
													Update
												</button>
											)}
										</div>
									</form>
								</div>
							</div>
							{/* <!-- card end// --> */}
						</div> : ""
					}
				</div>

			</section>
		</div>
	);
};

export default ViewCategoryForm;
